angular.module('storefront.account')
    .component('vcAccountQuotes', {
        templateUrl: 'themes/assets/js/account/account-quotes.tpl.liquid',
        require: {
            accountManager: '^vcAccountManager',
        },
        controller: [function () {
            const ctrl = this;

            ctrl.pageSettings = {
                currentPage: 1,
                itemsPerPageCount: 5,
                numPages: 10,
            };

            ctrl.pageSettings.pageChanged = function () {
                ctrl.accountManager.getQuotes(
                    ctrl.pageSettings.currentPage,
                    ctrl.pageSettings.itemsPerPageCount,
                    ctrl.sortInfos,
                    function (data) {
                        ctrl.entries = data.results;
                        ctrl.pageSettings.totalItems = data.totalCount;
                    },
                );
            };

            this.$routerOnActivate = function (next) {
                ctrl.pageSettings.currentPage = next.params.pageNumber || ctrl.pageSettings.currentPage;
                ctrl.pageSettings.pageChanged();
            };
        }],
    });
